import { Injectable } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { LoaderService } from '../services/loader.service'
import { finalize, tap } from 'rxjs/operators'
import { environment } from '../../environments/environment'

@Injectable()
export class MyHttpInterceptorInterceptor implements HttpInterceptor {
  private totalRequests = 0
  constructor(private loadingService: LoaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.totalRequests++
    this.loadingService.setLoading(true)
    const token = localStorage.getItem('token')
    const ignore =
      typeof request.body === 'undefined' ||
      request.body === null ||
      request.body.toString() === '[object FormData]' ||
      request.headers.has('Content-Type')
    if (ignore) {
      let clonedOptions: any = {
        setHeaders: {
          'Content-Language': 'all',
          Authorization: `Bearer ${token}`,
          Accepts: 'application/json',
        },
        responseType: 'json',
      }

      const isS3Upload = request.url.includes('s3.amazon')
      if (isS3Upload) {
        clonedOptions = {
          setHeaders: {
            'Content-Language': 'all',
            Accepts: 'application/xml',
          },
          responseType: 'text',
        }
      }

      if (request.responseType === 'blob') {
        clonedOptions = {
          setHeaders: {
            'Content-Language': 'all',
            Authorization: `Bearer ${token}`,
            Accepts: '*/*',
          },
          responseType: 'blob',
        }
      }

      request = request.clone(clonedOptions)
      return next.handle(request).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse && !environment.production) {
              console.log('✅ HTTP Response:', {
                url: request.url,
                status: event.status,
                body: event.body,
                bodyType: typeof event.body,
              })
            }
          },
          (error: any) => {
            if (error instanceof HttpErrorResponse && !environment.production) {
              console.error('❌ HTTP Error:', {
                url: request.url,
                status: error.status,
                statusText: error.statusText,
                error: error.error,
                errorType: typeof error.error,
                errorStringified: JSON.stringify(error.error, null, 2),
                headers: error.headers.keys().reduce((acc: any, key: string) => {
                  acc[key] = error.headers.get(key)
                  return acc
                }, {}),
                message: error.message,
              })
            }
          },
        ),
        finalize(() => {
          this.totalRequests--
          if (this.totalRequests == 0) {
            this.loadingService.setLoading(false)
          }
        }),
      )
    }

    request = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Content-Language': 'all',
        Authorization: `Bearer ${token}`,
      },
    })

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && !environment.production) {
            console.log('✅ HTTP Response:', {
              url: request.url,
              status: event.status,
              body: event.body,
              bodyType: typeof event.body,
            })
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse && !environment.production) {
            console.error('❌ HTTP Error:', {
              url: request.url,
              status: error.status,
              statusText: error.statusText,
              error: error.error,
              errorType: typeof error.error,
              errorStringified: JSON.stringify(error.error, null, 2),
              headers: error.headers.keys().reduce((acc: any, key: string) => {
                acc[key] = error.headers.get(key)
                return acc
              }, {}),
              message: error.message,
            })
          }
        },
      ),
      finalize(() => {
        this.totalRequests--
        if (this.totalRequests == 0) {
          this.loadingService.setLoading(false)
        }
      }),
    )
  }
}
